import { render, staticRenderFns } from "./mob-header.vue?vue&type=template&id=15bd9587&scoped=true&"
import script from "./mob-header.vue?vue&type=script&lang=js&"
export * from "./mob-header.vue?vue&type=script&lang=js&"
import style0 from "./mob-header.vue?vue&type=style&index=0&id=15bd9587&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd9587",
  null
  
)

export default component.exports